import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import {
  type IListPublicChallengeTranslationsBySlugV1ResponseData,
  listPublicChallengeTranslationsBySlugV1ResponseSchema,
} from './list-public-challenge-translations-by-slug-v1-response';

export async function listPublicChallengeTranslationsBySlugV1Api(slug: string) {
  return getRequest<IAPI<IListPublicChallengeTranslationsBySlugV1ResponseData>>({
    path: `/challenges/v3/slug/${encodeURIComponent(slug)}/translations/v1`,
    schema: listPublicChallengeTranslationsBySlugV1ResponseSchema,
  });
}
